import { Box, Inline } from 'braid-design-system';
import { useAtomValue } from 'jotai';

import type { Country } from '../../entities/Country';
import { checkSupportedCards } from '../../usecases/CreditCard/cards';
import type { CreditCardBrandInput } from '../../usecases/CreditCard/creditcardTypes';
import { allSurchargesAtom } from '../../usecases/Surcharges/SurchargeStore';

import { BrandIcon } from './BrandIcon';

const supportedBrands: CreditCardBrandInput[] = ['VISA', 'MASTER_CARD', 'AMEX'];

interface Props {
  highlightBrand: CreditCardBrandInput;
  country: Country;
}

const AcceptedBrands = ({ highlightBrand, country }: Props) => {
  const allSurcharges = useAtomValue(allSurchargesAtom);

  const brandsWithSurcharge: string[] = allSurcharges
    ? allSurcharges.map((brandSurcharge) => brandSurcharge.brand)
    : [];

  const supportedCards = checkSupportedCards(country);
  const filteredBrands = supportedBrands.filter((brand) =>
    supportedCards.includes(brand.toLowerCase().replace(/_/g, '')),
  );

  return (
    <Box>
      <Inline space="xxsmall">
        {filteredBrands.map((brand) => {
          const hasSurcharge = brandsWithSurcharge.includes(brand);
          return (
            <BrandIcon
              key={brand}
              hasSurcharge={hasSurcharge}
              brand={brand}
              active={brand === highlightBrand || highlightBrand === 'UNKNOWN'}
            />
          );
        })}
      </Inline>
    </Box>
  );
};

export { AcceptedBrands };
